import React, { FC } from 'react';
import styles from './ComputerIcon.scss';
import { IOuter } from './ComputerIcon.types';

export const ComputerIcon: FC<IOuter> = () => <div className={styles.computerIcon} />;
